import React from 'react'

interface AnswerContainerProps{
  title: string,
  data: React.ReactNode
}

const AnswerContainer: React.FC<AnswerContainerProps> = ({ title, data }) => {
  const isString = typeof data === 'string';
  return (
    <div className="answerContainer">
      <h2 className="answerTitle">{title}:</h2>
      {isString ? (
        <p className="answerDescription">{data}</p>
      ) : (
        <div className="answerDescription">{data}</div>
      )}
    </div>
  );
}

export default AnswerContainer